import { useTranslation } from 'react-i18next';
import heroImage from 'src/assets/images/equipments.webp';
import { ImagedPage } from 'src/components';

export const Equipment = () => {
    const { t } = useTranslation('equipments');

    return (
        <ImagedPage src={heroImage} reversed>
            <h1>{t('title')}</h1>
            <p>{t('text.1')}</p>
            <p>{t('text.2')}</p>
            <p>{t('text.3')}</p>
            <p>{t('text.4')}</p>
        </ImagedPage>
    );
};
